import {createUseStyles} from "react-jss";
import {colors} from "constants/colors";
import {breakpoints} from "constants/breakpoints";

const styles = createUseStyles({
  promotionsPage: {
  },
});

export default styles;